import { Box } from "@mui/material";
import React from "react";
import styles from "./ActivityList.module.css";
import moment from "moment";
import stageDot from "../../assets/images/stage-dot.svg";
import nameLine from "../../assets/images/name-line.svg";
import getTeamMember from "../CommonFunctions/CommonFunctions";

function ActivityPayment(props: any) {
  const { data, employees, selectedCurrency, activityType } = props;

  return (
    <>
      <Box
        sx={{
          width: "100%",
          margin: "0 15px 22px 15px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className={styles.activityTop}>
            <div className={styles.activityDateStyle}>
              {moment(data?.creationDate).format("DD MMM YYYY, hh:mm A")}
            </div>
            <div className={styles.activityHeadStage}>
              <div className={styles.activityHeadStageIcon}>
                <img src={stageDot} alt="" />
              </div>
              <div>{data?.currentStage}</div>
            </div>
            <div className={styles.activityHeadName}>
              <div className={styles.activityHeadStageIcon}>
                <img src={nameLine} alt="" />
              </div>
              <div style={{ textTransform: "capitalize" }}>
                {/* {data?.createdByName} */}
                {getTeamMember(data?.createdById, employees)?.firstName +
                  " " +
                  getTeamMember(data?.createdById, employees)?.lastName}
              </div>
            </div>
          </div>
          <div
            className={styles.activityDemoTitle}
            style={{
              color:
                activityType === "TRANSACTION_DELETED" ? "#EC3939" : "#142C44",
            }}
          >
            {data.activityType?.toLowerCase()?.replace(/_/g, " ")}
          </div>
          {activityType !== "TRANSACTION_DELETED" ? (
            <div className={styles.activityPaymentStatementBox}>
              <div className={styles.activityPaymentStatementItem}>
                <div className={styles.activityPaymentStatementLabel}>
                  {data.activityType === "PAYMENT_FAILED" ? "Amount" : "Amount"}
                  :
                </div>
                <div className={styles.activityPaymentStatementValue}>
                  {selectedCurrency + " " + data?.paymentData?.amountReceived}
                  .00
                </div>
              </div>
              <div className={styles.activityPaymentStatementItem}>
                <div className={styles.activityPaymentStatementLabel}>
                  Balance:
                </div>
                <div className={styles.activityPaymentStatementValue}>
                  {selectedCurrency +
                    " " +
                    data?.paymentData?.balance?.toFixed(2)}
                </div>
              </div>
              <div className={styles.activityPaymentStatementItem}>
                <div className={styles.activityPaymentStatementLabel}>
                  Payment Source:
                </div>
                <div className={styles.activityPaymentStatementValue}>
                  {data?.paymentData?.paymentSource}
                </div>
              </div>
            </div>
          ) : (
            <div
              className={styles.activityDescription}
              dangerouslySetInnerHTML={{ __html: data?.description }}
            />
          )}
        </Box>
      </Box>
    </>
  );
}

export default ActivityPayment;
